import { decimal } from '@snap-types/schemas/decimal';
import z from 'zod';

import { AlphaQuoteEvaluationStatus } from '../enums';
import { base } from './base';
import { strictCalculatedData, strictInputs } from './strict';

export const inputs = {
  ...strictInputs,

  quantity: decimal.nullish(),
};

export const alphaQuotePriceRelaxedInputsSchema = z.object(inputs);

export type AlphaQuotePriceRelaxedInputs = z.output<
  typeof alphaQuotePriceRelaxedInputsSchema
>;

export const calculatedData = {
  ...strictCalculatedData,

  totalPreTrimWeight: decimal.nullish(),
  totalFinalWeight: decimal.nullish(),

  headingRunHours: decimal.nullish(),
  headingLaborReduction: decimal.nullish(),
  headingLaborCost: decimal.nullish(),
  headingBurdenReduction: decimal.nullish(),
  headingBurdenCost: decimal.nullish(),
  headingCost: decimal.nullish(),

  rollingRunHours: decimal.nullish(),
  rollingLaborReduction: decimal.nullish(),
  rollingLaborCost: decimal.nullish(),
  rollingBurdenReduction: decimal.nullish(),
  rollingBurdenCost: decimal.nullish(),
  rollingCost: decimal.nullish(),

  materialCost: decimal.nullish(),
  sems1TotalCost: decimal.nullish(),
  sems2TotalCost: decimal.nullish(),

  surfaceFinishCost: decimal.nullish(),
  toolingCost: decimal.nullish(),

  totalCost: decimal.nullish(),
  unitCost: decimal.nullish(),
  revenue: decimal.nullish(),
  finalGrossMargin: decimal.nullish(),

  grossMargin: decimal.nullish(),
  calculatedGrossMargin: decimal.nullish(),

  unitPrice: decimal.nullish(),
  calculatedUnitPrice: decimal.nullish(),

  leadTimeWeeks: z.number().int().nullish(),
  calculatedLeadTimeWeeks: z.number().int().nullish(),
};

export const alphaQuotePriceRelaxedCalculatedDataSchema =
  z.object(calculatedData);

export type AlphaQuotePriceRelaxedCalculatedData = z.output<
  typeof alphaQuotePriceRelaxedCalculatedDataSchema
>;

export const relaxed = {
  ...base,
  ...inputs,
  ...calculatedData,
  evaluationStatus: z.enum([
    AlphaQuoteEvaluationStatus.CALCULATION_ERROR,
    AlphaQuoteEvaluationStatus.CONSULT_ENGINEERING,
    AlphaQuoteEvaluationStatus.INCOMPLETE,
  ]),
};

export const alphaQuotePriceRelaxedSchema = z.object(relaxed);

export type AlphaQuotePriceRelaxed = z.output<
  typeof alphaQuotePriceRelaxedSchema
>;
